import social_x from '@assets/westminster-social-x.svg';
import social_instagram from '@assets/westminster-social-instagram.svg';
import social_facebook from '@assets/westminster-social-facebook.svg';
import social_linkedin from '@assets/westminster-social-linkedin.svg';
import wcc_logo from '@assets/wcc_logo_white.svg';

export const WCCFooterItems = {
  feedback: {
    url: 'https://www.westminster.gov.uk/form/page-feedback',
    text: 'Is there anything wrong with this page?',
  },
  menu: [
    {
      url: 'https://www.westminster.gov.uk/all-services',
      text: 'All council services',
    },
    {
      url: 'https://www.westminster.gov.uk/events',
      text: 'Events',
    },
    {
      url: 'https://www.westminster.gov.uk/news',
      text: 'News',
    },
    {
      url: 'https://www.westminster.gov.uk/newsletters',
      text: 'Newsletters',
    },
    {
      url: 'https://www.westminster.gov.uk/jobs',
      text: 'Jobs',
    },
  ],
  logo: {
    url: 'https://www.westminster.gov.uk/',
    ariaLabel: 'Back to homepage',
    alt: 'MyWestminster dashboard (footer)',
    src: wcc_logo,
  },
  socialMedia: [
    {
      url: 'https://en-gb.facebook.com/CityWestminster/',
      ariaLabel: 'Link to Facebook page',
      alt: 'Social Icon - Facebook',
      src: social_facebook,
    },
    {
      url: 'https://www.instagram.com/citywestminster',
      ariaLabel: 'Link to Instagram page',
      alt: 'Social Icon - Instagram',
      src: social_instagram,
    },
    {
      url: 'https://twitter.com/CityWestminster',
      ariaLabel: 'Link to X page',
      alt: 'Social Icon - X',
      src: social_x,
    },
    {
      url: 'https://www.linkedin.com/company/westminster-city-council',
      ariaLabel: 'Link to LinkedIn page',
      alt: 'Social Icon - LinkedIn',
      src: social_linkedin,
    },
  ],
  bottomLinks: [
    {
      url: 'https://www.westminster.gov.uk/accessibility',
      text: 'Accessibility',
    },
    {
      url: 'https://www.westminster.gov.uk/data-protection/privacy',
      text: 'Cookies',
    },
    {
      url: 'https://www.westminster.gov.uk/data-protection',
      text: 'Data protection',
    },
    {
      url: 'https://www.westminster.gov.uk/data-protection/freedom-information',
      text: 'Freedom of information',
    },
    {
      url: 'https://www.westminster.gov.uk/about-council/transparency/our-workforce#gender-and-ethnicity-pay-gap-reports',
      text: 'Pay gap report',
    },
    {
      url: 'https://www.westminster.gov.uk/modern-slavery-statement',
      text: 'Modern Slavery',
    },
    {
      url: 'https://www.westminster.gov.uk/terms-and-conditions',
      text: 'Terms and conditions',
    },
    {
      url: 'https://www.westminster.gov.uk/about-council/contact-us',
      text: 'Contact us',
    },
  ],
};
